import React from "react";
import { Link } from "react-router-dom";

import LeaguesTable from "./Table";

import {
    globalActions,
    selectSetting,
} from "../../features/global/globalSlice";
import { leagueManagementActions } from "../../features/leaguemgmt/leagueManagementSlice";
import { store } from "../../index";

export const loader = async () => {
    const leagues = store.getState().leaguemanagement.leagues;
    const years = store.getState().leaguemanagement.years;
    let settings = store.getState().global.settings;

    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    await Promise.resolve(settingsPromise);

    settings = store.getState().global.settings;
    const currentYear = selectSetting(
        store.getState(),
        "majorybl_current_league_year",
    );

    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(
              leagueManagementActions.getLeagues(currentYear?.setting),
          );

    const yearsPromise = years
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getYears());

    await Promise.all([leaguesPromise, yearsPromise]);

    return null;
};

const LeagueManagementIndex = (): React.JSX.Element | undefined => {
    return (
        <>
            <Link
                to={`/league-management/league/add`}
                className="btn btn-primary createButton mt-0"
            >
                Create League
            </Link>
            <LeaguesTable />
        </>
    );
};

export default LeagueManagementIndex;
